import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { getEnvConfig } from '@configs/env';
import { IconButton, useTheme } from '@mui/material';
import { CloseIcon, GlobeIcon, ListIcon } from '@icons/index';
import { getDomainFromBaseUrl } from '@utils/urlUtils';
import i18n from '@locales/i18n';
import * as S from './MobileGnbStyles';

export const MobileGnb = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { INTRODUCTION_PAGE, COMPANY_ID, ENABLED_PRIVACY_POLICY } = getEnvConfig();

  // KT_DS가 아닌 경우에만 introduction 라우트 추가
  const gnbItem = [
    ...(INTRODUCTION_PAGE === 'true'
      ? [
          {
            id: 0,
            name: t('GNB_Menu_01'),
            to: '/introduction',
          },
        ]
      : []),
    {
      id: 1,
      name: t('GNB_Menu_02'),
      to: '/store',
    },
    ...(ENABLED_PRIVACY_POLICY === 'true'
      ? [
          {
            id: 2,
            name: t('Sign_In_08'),
            to: '/privacy-policy',
          },
        ]
      : []),
  ];
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handleIntroduceInquiryClick = () => {
    setOpen(false);
    navigate('/tenant-request');
  };
  const [isLangOpen, setIsLangOpen] = useState<boolean>(false);
  const dimmedtRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  const renderGnbList = () => (
    <S.MGnbListWrap onClick={() => setOpen(false)} role="presentation">
      {gnbItem.map(item => (
        <S.MGnbListItem key={item.id} onClick={() => navigate(item.to)}>
          <span>{item.name}</span>
        </S.MGnbListItem>
      ))}
    </S.MGnbListWrap>
  );

  const handleChangeLang = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);

    const isSecure = window.location.protocol === 'https:';
    const secureAttr = isSecure ? ' secure;' : '';

    // COMPANY_ID에 따른 도메인 설정
    const domainAttr = getDomainFromBaseUrl();
    const cookieString = `SMP_lang=${lang}; path=/;${secureAttr} ${domainAttr}`;
    document.cookie = cookieString;

    setIsLangOpen(false);
  };
  const handleToggle = () => {
    setIsLangOpen(!isLangOpen);
  };

  return (
    <>
      <IconButton onClick={() => setIsLangOpen(true)}>
        <GlobeIcon
          width={26}
          height={26}
          color={isLangOpen ? theme.colors['ic-primary'] : theme.colors['ic-gray-main']}
        />
      </IconButton>
      <IconButton onClick={() => setOpen(true)}>
        <ListIcon width={28} height={28} />
      </IconButton>
      <S.StyledDrawer open={open} anchor="right" onClose={() => setOpen(false)}>
        <S.MGnbWrap>
          <S.MGnbHeader>
            <S.MGnbLogoLinkWrap to="/">
              <img
                src={COMPANY_ID === 'KT_DS' ? '/logo-ktds.png' : '/logo-mobile.png'}
                alt="Logo"
                style={{ width: '100%', height: '100%', objectFit: 'scale-down' }}
              />
            </S.MGnbLogoLinkWrap>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon width={28} height={28} />
            </IconButton>
          </S.MGnbHeader>
          <S.IntroductionBtn onClick={handleIntroduceInquiryClick}>
            <span>{t('GNB_Menu_04')}</span>
          </S.IntroductionBtn>
          {renderGnbList()}
        </S.MGnbWrap>
      </S.StyledDrawer>
      {open ||
      pathname === '/tenant-request' ||
      (pathname !== '/store/softwares' && pathname !== '/store/hardwares') ? null : (
        <S.IntroductionBtn className="fixed" onClick={handleIntroduceInquiryClick}>
          <span>{t('GNB_Menu_04')}</span>
        </S.IntroductionBtn>
      )}
      {createPortal(
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {isLangOpen && (
            <>
              <S.Languages>
                <S.Language
                  onClick={() => handleChangeLang('ko')}
                  className={i18n.language === 'ko' ? 'ko' : undefined}
                >
                  <span className={i18n.language === 'ko' ? 'ko' : undefined}>{t('Language.Korean')}</span>
                </S.Language>
                <S.Language
                  onClick={() => handleChangeLang('en')}
                  className={i18n.language === 'en' ? 'en' : undefined}
                >
                  <span className={i18n.language === 'en' ? 'en' : undefined}>English</span>
                </S.Language>
              </S.Languages>
              <S.Dimmed ref={dimmedtRef} onClick={handleToggle} />
            </>
          )}
        </>,
        document.body,
      )}
    </>
  );
};
